import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddTeacher = () => {
  const navigate=useNavigate()
  const [users, setUsers] = useState([]); // ✅ initialize as array
  const [selectedUser, setSelectedUser] = useState("");
  const [loading,setLoading]=useState(false)


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/marketplace/university/user-profiles/`,
          {
            params:{
               filter_key:'teacher'
            },

            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );

        // console.log("Users API Response:", res.data);

        // ✅ handle paginated OR normal response
        setUsers(res.data.results || res.data || []);
      } catch (error) {
        console.log("Error while getting profiles", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);

  const handleAddTeacher = async () => {
    try {
      setLoading(true)
      await axios.post(
        `${BASE_URL}/teacher/university/teacher/`,
        {
          profile_id: selectedUser, // ✅ send selected user id
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      // console.log("Dean Created:", res.data);
      alert("Teacher added successfully");
      navigate(-1)
      setSelectedUser("");
    } catch (error) {
      alert(error.response?.data?.error);
      console.log("Error while creating teacher", error?.response);
    }finally{
      setLoading(false)
    }
  };

  return (
    <>
     {/* Buttons */}
<div className="flex items-center justify-center gap-4 mb-6">
  <button
    type="button"
    
    className={`px-5 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${
     "bg-white text-gray-700 border border-gray-300 hover:border-gray-400"
    }`}
  >
    Select Teacher From Existing Users
  </button>

</div>

  <div className="bg-white rounded-2xl border border-gray-200 p-6 max-w-md mx-auto">
    <h2 className="text-lg font-semibold text-gray-900 mb-4">Select Existing User</h2>

    <select
      value={selectedUser}
      onChange={(e) => setSelectedUser(e.target.value)}
      className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 16px center'
      }}
    >
      <option value="">-- Select Teacher --</option>

      {users.length > 0 ? (
        users.map((user) => (
          <option
            key={user.profile_id || user.id}
            value={user.profile_id || user.id}
          >
            {user.name || user.full_name} ({user.email})
          </option>
        ))
      ) : (
        <option disabled>No users found</option>
      )}
    </select>

    {selectedUser && (
      <button
        onClick={handleAddTeacher}
        className="mt-4 w-full bg-[#0f6abf] text-white py-3 rounded-xl font-medium hover:bg-[#0a5ca8] transition-all disabled:opacity-50 flex items-center justify-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span>Linking Teacher...</span>
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
            Add Teacher
          </>
        )}
      </button>
    )}
  </div>


    
    </>
  );
};

export default AddTeacher;
